import Vue from 'vue';

export default {
    getAll() {
        return Vue.prototype.$axiosMainClient.get('/CustomFields');
    },
    create(customField) {
        return Vue.prototype.$axiosMainClient.post('/CustomFields', customField);
    },
    update(id, customField) {
        return Vue.prototype.$axiosMainClient.put(`/CustomFields/${id}`, customField);
    },
    delete(id) {
        return Vue.prototype.$axiosMainClient.delete(`/CustomFields/${id}`);
    },
    updateValue(workOrderIdPublic, customFieldIdPublic, textValue, boolValue, customFieldOptionId = null) {
        return Vue.prototype.$axiosMainClient.put('/WorkOrderCustomFieldValues', {
            workOrderIdPublic,
            customFieldIdPublic,
            textValue,
            boolValue,
            customFieldOptionId
        });
    }
};
